import './bento-content.scss';

// Effet hover croisé sur les paires d'items des colonnes verticales.
const containers = document.querySelectorAll('.bento-content') as NodeListOf<HTMLElement>;

containers?.forEach(container => {
    if (container.dataset.bentoInit) return;
    container.dataset.bentoInit = 'true';

    const content = container.querySelector('.items.vertical') as HTMLDivElement;

    if (!content) return;

    const wrappers = content.querySelectorAll('.items__wrapper') as NodeListOf<HTMLDivElement>;

    wrappers?.forEach(wrapper => {
        const items = wrapper.querySelectorAll('.item') as NodeListOf<HTMLDivElement>;

        items?.forEach((item, index) => {
            index === 0 && item.addEventListener('mouseenter', () => wrapper.classList.add('hover-first'));
            index === 1 && item.addEventListener('mouseenter', () => wrapper.classList.add('hover-last'));
            index === 0 && item.addEventListener('mouseleave', () => wrapper.classList.remove('hover-first'));
            index === 1 && item.addEventListener('mouseleave', () => wrapper.classList.remove('hover-last'));
        });
    });
});
